<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="student.urlProfilePhoto"
    >
      <template v-slot:header>
        {{$t('notifications.refusedLessonTime')}}
      </template>
      <router-link :to="`/students/${student.slug}`" class="font-medium">
        {{student.name}}
      </router-link>
      {{$t('notifications.studentRefused')}}
      <template v-slot:actions>
        <p class="pt-3 text-base">
          <span class="px-2 py-1 font-medium uppercase bg-red-500 text-white rounded-lg
            mr-2"> {{$t('notifications.newTime')}}: </span>
          {{ formattedNewSlotStartDate }}
        </p>
        <button class="rounded-sm px-2 py-1 text-orange-academy-300 mt-2 uppercase
          border opacity-60 hover:opacity-100 border-orange-academy-300"
          @click="goToCalendar">
            {{$t('notifications.proposeNewTime')}}
        </button>
      </template>
    </notification-template>
  </div>
</template>

<script>

import NotificationTemplate from './NotificationTemplate.vue';
import NotificationsMixin from '../../mixins/NotificationsMixin';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NotificationTemplate,
  },
  data() {
    return {
      new_slot: { ...this.notification.data.new_slot },
      student: { ...this.notification.data.student },
    };
  },
  mixins: [NotificationsMixin],
  methods: {
    goToCalendar() {
      this.$router.push({ name: 'teacher calendar' });
    },
  },
};
</script>
